import { css } from "@emotion/react";
import { Editor } from "codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/handlebars/handlebars";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/theme/dracula.css";
import { useCallback, useRef } from "react";
import * as React from "react";
import { Controlled as CodeMirror } from "react-codemirror2";
import { useSelector } from "react-redux";

import Block from "components/layout/Block";
import { selectIsDarkMode } from "store/features/app";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import ValidationBar from "./components/ValidationBar";
import { EditorWrapper } from "./components/styled";
import { ContentType } from "./constants";

interface IEditTemplateProps {
  contentType: ContentType;
  templates: Record<ContentType, string>;
  disabled: boolean;
  onContentChange: (contentType: ContentType, content: string) => void;
  isBannerVisible: boolean;
}

const EditTemplate: React.FC<IEditTemplateProps> = ({
  contentType,
  templates,
  onContentChange,
  disabled,
  isBannerVisible,
}) => {
  const editor = useRef<Editor | null>(null);
  const isDarkModeTheme = useSelector(selectIsDarkMode);

  const content = templates[contentType];
  const mode = {
    [ContentType.HTML]: { name: "handlebars", base: "text/html" },
    [ContentType.PlainText]: { name: "handlebars", base: "text/plain" },
  }[contentType];

  const handleChange = useCallback(
    (_editor: Editor, _data: unknown, value: string) => {
      onContentChange(contentType, value);
    },
    [contentType, onContentChange]
  );

  return (
    <Block paddingV="10px">
      <EditorWrapper isBannerVisible={isBannerVisible}>
        <ValidationBar templates={templates} contentType={contentType} disabled={disabled} editor={editor} />
        <CodeMirror
          editorDidMount={(editorInstance: Editor) => {
            editor.current = editorInstance;
          }}
          className={disabled ? "editor-disabled" : undefined}
          css={css`
            && .CodeMirror-wrap pre {
              word-break: break-word;
            }
          `}
          value={content}
          options={{
            mode,
            theme: isDarkModeTheme ? "dracula" : "default",
            lineNumbers: true,
            viewportMargin: Infinity,
            lineWrapping: true,
            readOnly: disabled && "nocursor",
          }}
          onBeforeChange={handleChange}
        />
      </EditorWrapper>
    </Block>
  );
};

export default EditTemplate;
